import { customerApi } from "../../utils/apiConfig";

export const getSignedUrl = (type, id) => {
  return customerApi.get(`/generateSignedUrl/${type}/${id}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};


export const putPinnedApi = (type, id) => {
  return customerApi.get(`/togglePinnedDocument/${type}/${id}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};


export const uploadSharedDocument = (category, userId, file, title, description, reminder) => {
  const formData = new FormData();
  formData.append("category", category)
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("excel", file);

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");

    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30, //  düz sayı gönder
      })
    );
  }

  return customerApi.post(`/uploadSharedDocument/${category}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateSharedDocument = (category, updatedId, userId, file, title, description, reminder) => {
  const formData = new FormData();
  formData.append("category", category)
  formData.append("updatedId", updatedId);
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);

  if (file) {
    formData.append("excel", file);
  }

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");

    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30,
      })
    );
  }

  return customerApi.post(`/updateSharedDocument/${category}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getSharedDocument = (category) => {
  return customerApi.get(`/getSharedDocuments/${category}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getAllSharedDocuments = (category = "all") => {
  return customerApi.get(`/getAllSharedDocuments/${category}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteSharedDocument = (category,userId, deletedId) => {
  return customerApi.post(
    `/deleteSharedDocument/${category}`,
    JSON.stringify({ category,userId, deletedId }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};





